import { QueryAllScoresRequestParamsDto } from '../../dto/scores/request/query-all-scores-request.dto';
import { QueryMaxScoresRequestParamsDto } from '../../dto/scores/request/query-user-max-scores-request.dto';
import { QueryAverageScoresRequestParamsDto } from '../../dto/scores/request/query-user-average-scores-request.dto';
import { QueryPerWeekdayAverageScoresRequestParamsDto } from '../../dto/scores/request/query-per-weekday-average-scores-request.dto';
import { UserAllScoresResult } from '../../dto/scores/cube/mapped/user-all-scores-results.dto';
import { QueryScoreTimeSeriesRequestParamsDto } from '../../dto/scores/request/query-score-time-series-request.dto';
import { ScoreTimeSeriesResult } from '../../dto/scores/cube/mapped/score-time-series-results.dto';
import { CubeConfigDto } from '../../dto/common/request/cube-config.dto';

  export interface IAllScoresRepository {
    queryUserAllScores(
      params: QueryAllScoresRequestParamsDto,
      config: CubeConfigDto
    ): Promise<UserAllScoresResult[]>;
    queryUserMaxScores(
      params: QueryMaxScoresRequestParamsDto,
      config: CubeConfigDto
    ): Promise<UserAllScoresResult[]>;
    queryUserAvgScores(
      params: QueryAverageScoresRequestParamsDto,
      config: CubeConfigDto
    ): Promise<UserAllScoresResult>;
    queryPerWeekdayAverageAllScores(
      params: QueryPerWeekdayAverageScoresRequestParamsDto,
      config: CubeConfigDto
      ): Promise<UserAllScoresResult>;
    queryScoreTimeSeries(
      params: QueryScoreTimeSeriesRequestParamsDto,
      config: CubeConfigDto
      ): Promise<ScoreTimeSeriesResult[]>
  }
  